<template>
    <div>
        <br/>
        <div class="col-12">
            <nav class="navbar navbar-expand-lg navbar-light">
                <div class="ml-auto">
                    <form v-on:keypress.enter.prevent="searchInvoice(1)"
                          class="form-inline my-2 my-lg-0">
                        <input
                            class="form-control mr-sm-2"
                            type="search"
                            placeholder="ค้นหาเลขที่บิลขาย"
                            aria-label="Search"
                            v-model="search.invoice"/>
                        &nbsp;
                        <b-form-select
                            v-model="search.transport_type_id"
                            :options="transport"></b-form-select>&nbsp;
                        <date-picker v-model="search.date"
                                     range
                                     placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                                     :format="changeFormat"
                                     :lang="lang" confirm>
                        </date-picker>
                        &nbsp;
                        <template v-if="canViewAccounting">
                            <multiselect
                                v-model="search.sale"
                                class="form-control border-0"
                                :options="optionSeller"
                                label="name"
                                placeholder="ค้นหาเซลล์"
                                :show-labels="false"
                                :customLabel="customSaleNameWithCode"
                                track-by="id">
                            </multiselect>
                        </template>
                        <multiselect
                            v-model="search.product"
                            class="form-control border-0"
                            :options="optionProducts"
                            :customLabel="LabelSkuWithName"
                            placeholder="ค้นหาสินค้า"
                            :show-labels="false"
                            track-by="id">
                        </multiselect>
                        <select class="form-control" v-model="search.product_type_id">
                            <option
                                v-for="options in optionProductType"
                                :value="options.value">{{ options.text }}
                            </option>
                        </select>
                        <multiselect
                            v-model="search.customer"
                            class="form-control border-0"
                            :options="optionCustomer"
                            :customLabel="customerWithLabel"
                            placeholder="ค้นหาลูกค้า"
                            :show-labels="false"
                            track-by="id">
                        </multiselect>
                        <button
                            class="btn btn-success my-2 my-sm-0"
                            type="button"
                            @click="searchInvoice(1)">
                            <icon name="search"></icon>
                            ค้นหา
                        </button>
                        &nbsp
                        <button v-if="canViewAccounting"
                                @click="goToInvoiceForm(null)"
                                class="btn btn-warning my-2 my-sm-0"
                                type="button">
                            <icon name="plus"></icon>
                            สร้างใบบิล
                        </button>
                        &nbsp
                        <button type="button" v-if="canViewAccounting"
                                @click="createTaxNumber"
                                :disabled="checkbox_id.length < 1 || activeStatus != 1"
                                class="btn btn-default next">
                            <icon name="file-alt"></icon>
                            สร้างใบกำกับภาษี
                        </button>
                        &nbsp
                        <button type="button"
                                @click="printInvoiceReport"
                                class="btn btn-primary">
                            <icon name="print"></icon>
                            พิมพ์รายงานการขาย
                        </button>
                        &nbsp
                        <button type="button"
                                @click="printMultiInvoicePDF"
                                class="btn btn-success">
                            <icon name="print"></icon>
                            พิมพ์บิลขายหลายใบ
                        </button>
                        &nbsp
                        <button type="button"
                                @click="printPromotionReport"
                                class="btn btn-info">
                            <icon name="print"></icon>
                            พิมพ์รายงานโปรโมชั่น
                        </button>
                        &nbsp
                        <button type="button" v-if="canViewAccounting"
                                @click="printMultiCoverA5"
                                class="btn btn-info" style="background-color: #1E8CBE">
                            <icon name="print"></icon>
                            พิมพ์ใบปะหน้าขนส่ง
                        </button>
                        &nbsp
                        <button type="button"
                                v-if="canViewSuperAdmin"
                                @click="printInvoiceTaxReport"
                                class="btn btn-primary">
                            <icon name="print"></icon>
                            รายงานบิลขาย(ภาษี)
                        </button>
                    </form>
                </div>
            </nav>
            <!--status filter-->
            <b-navbar toggleable="md" type="light" variant="light">
                <b-navbar-toggle target="search_nav_collapse"></b-navbar-toggle>
                <b-collapse is-nav id="search_nav_collapse">
                    <b-navbar-nav>
                        <template v-for="data in invoiceStatus">
                            <b-nav-item class="item margin" :class="{ active: data.id === activeStatus }"
                                        @click="getFilterStatus(data.id)">
                                {{ data.name }}
                            </b-nav-item>
                        </template>
                    </b-navbar-nav>
                </b-collapse>
                <span style="color: red">**TN สถานะ <span style="text-decoration: underline">ชำระบางส่วน</span> , <span
                    style="text-decoration: underline">ชำระแล้ว</span> ไม่สามารถแก้ไข และ ลบบิลได้</span>
            </b-navbar>
        </div>
        <div class="col-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col" v-if="activeStatus === 1">
                        <input type="checkbox" v-model="selectAll"/>
                    </th> <!--1-->
                    <th>ใบกำกับภาษี</th>
                    <template v-if="canViewAccounting">
                        <th scope="col" v-if="activeStatus === 3">บันทึกรับ</th> <!--2-->
                    </template>
                    <th scope="col">เลขที่ใบแจ้งหนี้</th> <!--3-->
                    <th scope="col" v-if="activeStatus === 1 || activeStatus === 2">เลขที่ใบจอง</th> <!--4-->
                    <th scope="col">วันที่ใบแจ้งหนี้</th> <!--5-->
                    <th scope="col" v-if="activeStatus === 3">วันที่ส่งสินค้า</th> <!--6-->
                    <th scope="col" v-if="activeStatus === 5 || activeStatus === 6">วันครบกำหนดชำระ</th> <!--6.1-->
                    <th scope="col" style="padding-left: 40px;padding-right: 40px">เซลล์</th> <!--7-->
                    <th scope="col" style="padding-left: 25px;padding-right: 25px;min-width: 100px">รหัสลูกค้า</th>
                    <!--8-->
                    <th scope="col" style="min-width: 150px">ชื่อลูกค้า</th> <!--9-->
                    <th scope="col">ยอดเงิน</th> <!--10-->
                    <th scope="col" v-if="activeStatus === 1 || activeStatus === 2 || activeStatus === 3"
                        style="padding-left: 60px;padding-right: 60px">คนขับ
                    </th> <!--11-->
                    <th scope="col" v-if="activeStatus === 1 || activeStatus === 2 || activeStatus === 3">ประเภทรถ</th>
                    <!--11.1-->
                    <th scope="col">เลขที่ใบวางบิล</th><!--11.4-->
                    <th width="150px" scope="col">สถานะ</th> <!--12-->
                    <th scope="col" v-if="activeStatus === 3 || activeStatus === 4">การเก็บเงิน</th> <!--13-->
                    <th scope="col" v-if="activeStatus === 3
                    || activeStatus === 4 || activeStatus === 5 || activeStatus === 6">ช่องทาง / วันที่เข้าเช็ค
                    </th> <!--14-->
                    <th scope="col" v-if="activeStatus === 3 || activeStatus === 4">ยอดรับ</th> <!--15-->
                    <th scope="col" v-if="activeStatus === 5 || activeStatus === 6">ยอดชำระ</th> <!--16-->
                    <th scope="col" v-if="activeStatus === 4 || activeStatus === 5 || activeStatus === 6">ผู้บันทึกรับ
                    </th> <!--17-->
                    <th scope="col" v-if="activeStatus === 4 || activeStatus === 5 || activeStatus === 6">
                        วันที่บันทึกรับ
                    </th> <!--18-->
                    <th scope="col" v-if="activeStatus === 3">รูปถ่ายการส่งของ</th> <!--19-->
                    <th scope="col" v-if="activeStatus === 1">แก้ไขคนขับรถ</th> <!--19.1-->
                    <th scope="col" v-if="activeStatus === 1">พิมพ์บิลขาย</th> <!--20-->
                    <th scope="col" v-if="activeStatus === 1">พิมพ์บิลไม่มีราคา</th> <!--21-->
                    <th scope="col" v-if="activeStatus === 1">พิมพ์ใบขนส่ง</th> <!--21.1-->
                    <th scope="col" width="200px" v-if="activeStatus !== 8">แก้ไข / ยกเลิก</th> <!--23-->
                    <th scope="col" v-if="activeStatus === 1 || activeStatus ===8">เพิ่มเติม</th> <!--24-->
                    <th scope="col" v-if="activeStatus === 8">สาเหตุการยกเลิก</th> <!--25-->
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in InvoiceList" :class="{'font-weight-bold' : checkbox_id.includes(data)}">
                    <td v-if="activeStatus === 1">
                        <input type="checkbox" :value="data"
                               v-model="checkbox_id"/>
                        <div style="display: none" v-if="data.status_tax == 1">
                        </div>
                    </td> <!--1-->
                    <td>
                        <template v-if="data.status_tax">
                            <icon name="check" color="green"></icon>
                        </template>
                        <template v-else>
                            <icon name="times" color="red"></icon>
                        </template>
                    </td>
                    <template v-if="canViewAccounting">
                        <td v-if="activeStatus === 3">
                            <template v-if="data.save_exportation.length > 0">
                                <template
                                    v-if="data.save_exportation.some(exportation => exportation.payment_type_id != 1)">
                                    <button type="button" class="btn btn-success"
                                            :disabled="data.remaining_payoff < 1"
                                            @click="goToTransaction(data.id)">บันทึกรับ
                                    </button>
                                </template>
                                <template v-else>
                                    <button type="button" class="btn btn-success"
                                            @click="showModalSaveExportation(data.id)">บันทึกรับ
                                    </button>
                                </template>
                            </template>
                        </td> <!--2-->
                    </template>
                    <td>{{ data.invoice_id }}</td><!--3-->
                    <td v-if="activeStatus === 1 || activeStatus === 2"><!--4-->
                        <template v-if="data.order_number">
                            {{ data.order_number }}
                        </template>
                        <template v-else>
                            <p>-</p>
                        </template>
                    </td>
                    <td>{{ data.date | moment("DD/MM/YYYY") }}</td><!--5-->
                    <td v-if="activeStatus === 3">
                        <template v-if="data.save_exportation.length > 0" v-for="item in data.save_exportation">
                            {{ item.created_at | moment("DD/MM/YYYY") }}
                        </template>
                    </td><!--6-->
                    <td v-if="activeStatus === 5 || activeStatus === 6">
                        {{ data.due_date | moment("DD/MM/YYYY") }}
                    </td><!--6.1-->
                    <td><!--7-->
                        <template v-if="data.customer && data.customer.sale">
                            {{ data.customer.sale.name }}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td><!--8-->
                        <template v-if="data.customer">
                            {{ data.customer.customer_id }}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td><!--9-->
                        <template v-if="data.customer">
                            <template v-if="data.customer_other">
                                {{ data.customer.store_name ? data.customer.store_name : data.customer.first_name }} /
                                {{
                                    data.customer_other.store_name ? data.customer_other.store_name : data.customer_other.first_name
                                }}
                            </template>
                            <template v-else>
                                {{ data.customer.store_name ? data.customer.store_name : data.customer.first_name }}
                            </template>
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td><!--10-->
                        <template v-if="data.cash_back">
                            {{ data.total - parseFloat(data.cash_back) | currency }}
                        </template>
                        <template v-else>
                            {{ data.total | currency }}
                        </template>
                    </td>
                    <td v-if="activeStatus === 1 || activeStatus === 2 || activeStatus === 3"><!--11-->
                        <template v-if="data.driver">
                            {{ data.driver.name }}<br/>({{ data.driver.phone }})
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td v-if="activeStatus === 1 || activeStatus === 2 || activeStatus === 3"><!--11.1-->
                        <template v-if="data.transport_type_id">
                            {{ data.transport_type_name }}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td>
                        <template v-if="data.billing_id">
                            {{ data.billing_number }}
                        </template>
                        <template v-else>-</template>
                    </td><!--11.4-->
                    <td><!--12-->
                        <template v-if="data.status && data.status.id !== 1">
                            <a style="color: blue;">
                                {{ data.status.name }}
                            </a>
                        </template>
                    </td>
                    <td v-if="activeStatus === 3 || activeStatus === 4"><!--13-->
                        <template v-if="data.save_exportation.length > 0" v-for="payment in data.save_exportation">
                            {{ payment.payment_type_name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td v-if="activeStatus === 3 || activeStatus === 4 || activeStatus === 5 || activeStatus === 6">
                        <!--14-->
                        <template v-for="payment in data.payoff">
                            <template v-for="transaction in payment.transactions">
                                <span>{{ transaction.transaction_type.name }},</span>
                            </template>
                            <div v-for="cheque in payment.cheque_date">
                                <span>( {{ cheque.approve_date | moment('DD/MM/YYYY') }} )</span>
                            </div>
                        </template>
                    </td>
                    <td v-if="activeStatus === 3 || activeStatus === 4"><!--15-->
                        <template v-if="data.save_exportation.length > 0">
                            {{ data.save_exportation[0].amount | currency }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td v-if="activeStatus === 5 || activeStatus === 6"><!--16-->
                        {{ data.invoice_amount | currency }}
                    </td>
                    <td v-if="activeStatus === 4 || activeStatus === 5 || activeStatus === 6"><!--17-->
                        <template v-if="data.reciver_user">
                            {{ data.reciver_user.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td v-if="activeStatus === 4 || activeStatus === 5 || activeStatus === 6"><!--18-->
                        <template v-if="data.payoff">
                            {{ data.payoff.date | moment("DD/MM/YYYY") }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td v-if="activeStatus === 3"><!--19-->
                        <template v-if="data.save_exportation.length > 0 && data.save_exportation[0].image_file">
                            <template v-for="(x,i) in data.save_exportation[0].image_file.split(',')"
                                      v-if="i != data.save_exportation[0].image_file.split(',').length-1">
                                <a :href="domain.slice(0, -4)+'/file/'+x"
                                   style="color: blue;text-decoration:underline"
                                   target="_blank">
                                    ดูรูปถ่ายที่ {{ i + 1 }}
                                </a>
                            </template>
                            <!--                            <a :href="data.save_exportation[0].image_file" target="_blank"-->
                            <!--                               style="text-decoration: underline">ดูรูปภาพ</a>-->
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td v-if="activeStatus === 1"><!--19.1-->
                        <button class="btn btn-outline-danger" @click="showInvoiceDriver(data.id)">แก้ไขคนขับ</button>
                    </td>
                    <td v-if="activeStatus === 1"><!--20-->
                        <a :href="domain +'/invoice-pdf/' +data.id" target="_blank" class="btn btn-primary">
                            พิมพ์บิลขาย
                        </a>
                    </td>
                    <td v-if="activeStatus === 1"><!--21-->
                        <button class="btn btn-primary"
                                @click="showPrintFormModal(data.id)">
                            พิมพ์บิลไม่มีราคา
                        </button>
                    </td>
                    <td v-if="activeStatus === 1"><!--21.1-->
                        <button class="btn btn-success mb-2 mx-3"
                                @click="printTransportDetails(data.id)"
                                :disabled="data.transport_type_id != 4 || data.status_receive">
                            <icon name="address-card"></icon>
                            พิมพ์ใบขนส่ง
                        </button>
                    </td>
                    <td v-if="activeStatus !== 8"><!--23-->
                        <template v-if="data.invoice_status_id !== 8">
                            <a @click="goToInvoiceForm(data.id)">
                                <icon name="edit"></icon>
                            </a>
                            &nbsp&nbsp
                            <template v-if="canViewSuperAdmin">
                                <a v-if="!data.payoff_status_id && !data.status_product_return && data.invoice_status_id!=8"
                                   @click="showDeleteModal(data.id)">
                                    <icon name="trash"></icon>
                                </a>
                            </template>
                        </template>
                        <template v-else>
                            <span>สาเหตุ<br>{{ data.note }}</span>
                        </template>
                    </td>
                    <td v-if="activeStatus === 8 || activeStatus === 1"><!--24-->
                        <template v-if="data.invoice_status_id==8">
                            <button class="btn btn-outline-primary" @click="reOpenInvoiceForm(data.id)">
                                แก้ไข TN เดิม
                            </button>
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td v-if="activeStatus === 8"><!--25-->
                        <span>{{ data.note }}</span>
                    </td>
                </tr>
                <tr v-if="activeStatus === 1">
                    <td colspan="6" align="right" style="font-weight: bold">ยอดเงินรวมทั้งหมดในรายการ ที่ต้องการ
                        พิมพ์ส่งใบภาษี :
                    </td>
                    <td colspan="18" align="left" style="font-weight: bold">
                        {{ eventCheckBox | currency }} บาท
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div style="padding-left: 10px; color: red"><span>**TN ที่มีการสร้างบันทึกรับแล้วในเมนูตัดชำระ จะไม่สามารถกดบันทึกรับได้</span>
        </div>
        <div v-if="InvoiceList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getInvoiceListPage">
            </vue-pagination>
        </div>
        <br/>
        <!-- -Invoice SaveExportation- -->
        <b-modal hide-header hide-footer ref="Invoice_saveExportation">
            <div>
                <invoice-save-exportation-modal @submit="submitData">
                </invoice-save-exportation-modal>
            </div>
        </b-modal>
        <!-- -approve status- -->
        <b-modal hide-header hide-footer ref="approve">
            <div>
                <invoice-status-modal @submit="updateApprove">
                </invoice-status-modal>
            </div>
        </b-modal>
        <!-- -print form invoice- -->
        <b-modal size="lg" hide-header hide-footer ref="print_form_invoice">
            <div>
                <print-form-invoice-modal @submit="printFormInvoice">
                </print-form-invoice-modal>
            </div>
        </b-modal>
        <!-- -print invoice data- -->
        <b-modal hide-header hide-footer ref="print_invoice_report">
            <div>
                <print-report-invoice-modal @submit="printInvoiceReport">
                </print-report-invoice-modal>
            </div>
        </b-modal>
        <!-- -print edit driver- -->
        <b-modal hide-header hide-footer ref="edit_driver">
            <div>
                <edit-driver-modal @submit="hideEditDriverModal">
                </edit-driver-modal>
            </div>
        </b-modal>
        <!-- ------delete------- -->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการยกเลิกบิลใช่ไหม?</h4>
                <br/>
                <h4>สาเหตุการยกเลิก</h4>
                <textarea style="width: 80%;resize: none" v-model="note_message" rows="4"></textarea>
                <br/>
                <button :disabled="note_message.length == 0"
                        type="button"
                        class="btn btn-success"
                        @click="deleteInvoice">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideDeleteModal">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="loading" no-close-on-backdrop no-close-on-esc>
            <loading :msg="msg" :status="status_report" @submit="hideLoadingModal">
            </loading>
        </b-modal>
        <b-modal hide-header hide-footer ref="invoice_tax_report">
            <div style="text-align: center;">
                <h4>ใบกำกับภาษี</h4>
                <br/>
                <div class="row">
                    <span class="col-5">ประเภทใบภาษี</span>
                    <div class="col-6">
                        <select class="form-control" v-model="tax_report.type">
                            <option value="true">บิลขายที่มีใบกำกับภาษี</option>
                            <option value="false">บิลขายที่ไม่มีใบกำกับภาษี</option>
                            <option value="all">ทั้งหมด</option>
                        </select>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <span class="col-5">
                        เดือน-ปีที่ต้องการ
                    </span>
                    <div class="col-6">
                        <date-picker v-model="tax_report.date"
                                     format="MM-YYYY"
                                     class="w-100"
                                     :lang="lang"
                                     type="month"
                                     placeholder="เลือกเดือน-ปี">
                        </date-picker>
                    </div>
                </div>
                <br/>
                <button type="button"
                        class="btn btn-success"
                        @click="confirmTaxReport">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideInvoiceTaxReport">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import InvoiceStatusModal from "./InvoiceStatusModal";
import {domain} from "../../../util/Constants";
import VuePagination from "../../Pagination";
import PrintFormInvoiceModal from "./PrintFormInvoiceModal";
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import Multiselect from "vue-multiselect";
import {
    canSaleOrdersAllView,
    canSaleOrdersUpdate,
    canSaleView,
    canViewAccounting,
    canViewSuperAdmin,
} from "../../../util/Permissions";
import InvoiceSaveExportationModal from "./InvoiceSaveExportationModal";
import TreeMenu from "vue2-sidebar/src/components/TreeMenu";
import PrintReportInvoiceModal from "./PrintReportInvoiceModal";
import Loading from "../../Utility/Loading";
import EditDriverModal from "./EditDriverModal";

export default {
    components: {
        EditDriverModal,
        Loading,
        PrintReportInvoiceModal,
        TreeMenu,
        InvoiceSaveExportationModal,
        PrintFormInvoiceModal,
        VuePagination,
        InvoiceStatusModal,
        DatePicker,
        Multiselect,
    },
    name: "invoice-list",
    data() {
        return {
            msg: '',
            status_report: 1,
            optionCustomer: [],
            id: "",
            page: 1,
            activeCloseDate: false,
            dateFormat: 'D/MM/YYYY',
            search: {
                invoice: "",
                date: [],
                sale: "",
                customer: "",
                status: '',
                transport_type_id: '',
                product: null,
                product_type_id: ''
            },
            domain: "",
            event_submit: false,
            status: 1,
            checkbox_id: [],
            select_all: false,
            invoice_total: 0,
            disable_select_all: false,
            invoices: [], //tax_number
            currentDate: "",
            payment_type: [],
            date_week: [],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    return date ? moment(date).format('DD/MM/' + year) : null;
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            note_message: '',
            tax_report: {
                type: 'true',
                date: ''
            }
        };
    },
    created() {
        this.domain = domain;
        this.getInvoiceListPage();
        this.getCurrentDate();
        this.$store.dispatch("Common/setInvoiceStatus");
        this.$store.dispatch("Seller/get");
        this.$store.dispatch("Products/getProductAll");
        this.$store.dispatch('ProductType/get');
        this.getCustomerAll();
    },

    computed: {
        canSaleView,
        canSaleOrdersUpdate,
        canViewAccounting,
        canViewSuperAdmin,
        canSaleOrdersAllView,
        ...mapState({
            InvoiceList: state => {
                return state.Invoice.InvoiceList;
            },
            dataPaginate: state => {
                return state.Invoice.dataPaginate
            },
            invoiceStatus: state => {
                return state.Common.invoice_status;
            },
            activeStatus: state => {
                return state.Invoice.activeStatus;
            },
            optionInvoice: state => {
                return [
                    {
                        value: "",
                        text: "สถานะใบบิล"
                    },
                    ...state.Common.invoice_status
                        .filter(status => status.id !== 1)
                        .map(status => ({
                            value: status.id,
                            text: status.name
                        }))
                ];
            },
            optionProductType: state => {
                return [
                    {
                        value: "",
                        text: "หมวดหมู่สินค้า"
                    },
                    ...state.ProductType.data.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ];
            },
            transport: state => {
                return [
                    {
                        value: "",
                        text: "ค้นหาการขนส่ง"
                    },
                    ...state.TransportType.transportTypeList.map(trans => ({
                        value: trans.id,
                        text: trans.name
                    }))
                ];
            },
            eventCheckBox() {
                this.invoice_total = 0;
                let total = 0;
                this.checkbox_id.forEach(invoice => {
                    total += parseFloat(invoice.total);
                });
                return this.invoice_total = total;
            },
            optionSeller: state => {
                return state.Seller.data
            },
            user: state => {
                return state.Auth.user
            },
            optionProducts: (state) => {
                return state.Products.product_all;
            },
        }),
        selectAll: {
            get: function () {
                return this.InvoiceList ? this.checkbox_id.length >= this.InvoiceList.length : false;
            },
            set: function (value) {
                if (value) {
                    this.select_all = true;
                    this.searchInvoice();
                } else {
                    this.select_all = false;
                }
            }
        },
    },
    methods: {
        LabelSkuWithName(option) {
            if (this.optionProducts.length > 0) {
                return `${option.sku} - ${option.short_name}`
            }
        },
        validateDateRange() {
            let dates = [];
            if (this.search.date.length > 0) {
                let currentDate = moment(this.search.date[0]);
                let end_date = moment(this.search.date[1]);
                while (currentDate <= end_date) {
                    dates.push(moment(currentDate).format("YYYY-MM-DD"));
                    currentDate = moment(currentDate).add(1, 'days')
                }
                this.date_week = dates;
            }
        },
        getCustomerAll() {
            // this.$store.dispatch("Customer/setAllCustomer").then(customers=>{
            //     this.optionCustomer = customers;
            // }) ;
            this.$store.dispatch("Customer/setAllCustomerDropdown").then(customers => {
                this.optionCustomer = customers;
            });
        },
        customSaleNameWithCode(option) {
            return `${option.sale_id} - ${option.name}`
        },
        customerWithLabel(option) {
            return `${option.customer_id} - ${option.store_name}`
        },
        getCurrentDate() {
            this.currentDate = moment().format("YYYY-MM-DD");
        },
        showModalSaveExportation(id) {
            this.msg = 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่';
            this.status_report = 1;
            this.showLoadingModal();
            this.$store.dispatch("Invoice/show", id).then(() => {
                this.$refs.Invoice_saveExportation.show();
                this.hideLoadingModal();
            });
        },
        hideModalSAveExportation() {
            this.$refs.Invoice_saveExportation.hide();
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        showEditDriverModal() {
            this.$refs.edit_driver.show();
        },
        hideEditDriverModal(value) {
            this.$refs.edit_driver.hide();
            if (value) {
                this.getInvoiceListPage();
            }
        },
        showDeleteModal(id) {
            this.id = id;
            this.note_message = '';
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },
        showPrintFormModal(id) {
            this.$store.dispatch("Invoice/show", id).then(() => {
                this.$refs.print_form_invoice.show();
            });
        },
        hidePrintFormModal() {
            this.$refs.print_form_invoice.hide();
        },
        //from save exportation modal
        submitData(submitValue) {
            if (submitValue != 0) {
                /*หากไม่มีเก็บ บันทึกรับ โดยการเปลี่ยน status invoice อย่างเดียว ไม่ต้องบันทึกลง invoice_payoff*/
                /*change status to บันทึกรับเรียบร้อยแล้ว*/

                this.$store.dispatch("Invoice/changeInvoiceStatus", {
                    invoice_id: submitValue.invoice_id,
                    status: 4,
                    user_id: this.user.id
                }).then(() => {
                    this.$store.dispatch("Invoice/setInvoiceFilter", {status: 4})
                        .then(res => {
                            this.activeStatus = 4;
                            this.status = 4;
                        });
                })
            }
            this.hideModalSAveExportation();
        },
        goToInvoiceForm(id) {
            this.msg = 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่';
            this.status_report = 1;
            this.showLoadingModal();
            this.$store.dispatch("Invoice/clear_delete_product");
            if (id) {
                this.$store.dispatch("Invoice/show", id).then(() => {
                    this.$router.push({
                        name: "invoice-form",
                        params: {id}
                    });
                    this.hideLoadingModal();
                }).catch(err => {
                    this.msg = 'ดาวโหลดข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง';
                    this.status_report = 3;
                });
            } else {
                this.$store.dispatch("Invoice/clearFormData").then(() => {
                    this.$router.push({
                        name: "invoice-form",
                        params: {id}
                    });
                    this.hideLoadingModal();
                });
            }
        },
        showInvoiceDriver(id) {
            this.msg = 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่';
            this.status_report = 1;
            this.showLoadingModal();
            this.$store.dispatch("Invoice/show", id).then(() => {
                this.showEditDriverModal();
                this.hideLoadingModal();
            }).catch(err => {
                this.msg = 'ดาวโหลดข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง';
                this.status_report = 3;
            });
        },
        reOpenInvoiceForm(id) {
            this.$store.dispatch("Invoice/show", id).then(() => {
                this.$store.dispatch("Invoice/clearDetailInvoice").then(() => {
                    this.$router.push({
                        name: "invoice-form",
                        params: {reopenStatus: true, id}
                    });
                });
            });
        },
        searchInvoice(page = 1) {
            let customer = "";
            let sale = "";
            this.page = page;
            if (this.search.date.length > 0) {
                if (this.search.date[0] && this.search.date[1]) {
                    this.search.date[0] = moment(this.search.date[0]).format("YYYY-MM-DD");
                    this.search.date[1] = moment(this.search.date[1]).format("YYYY-MM-DD");
                } else {
                    this.search.date = [];
                }
            }
            if (this.search.customer) {
                customer = this.search.customer.id;
            }
            if (this.search.sale) {
                sale = this.search.sale.id
            }
            let product_id = this.search.product ? this.search.product.id : '';
            let data = {
                invoice_id: this.search.invoice,
                date: this.search.date,
                customer_id: customer,
                sale_id: sale,
                status: this.status,
                transport_type_id: this.search.transport_type_id,
                product_id,
                product_type_id: this.search.product_type_id,
            };
            this.event_submit = true;
            this.showLoadingModal();
            this.status_report = 1;
            this.msg = 'กรุณารอสักครู่';
            if (this.select_all) {
                this.$store.dispatch("Invoice/selectInvoiceAll", data).then(invoice => {
                    this.checkbox_id = invoice; //return invoice
                }).then(() => {
                    this.hideLoadingModal();
                }).catch(() => {
                    this.hideLoadingModal();
                    this.status_report = 3;
                    this.msg = 'ดาวโหลดข้อมูลไม่สำเร็จ';
                })
            } else {
                this.$store.dispatch("Invoice/search", {
                    page: this.page,
                    search: data,
                }).then(() => {
                    this.hideLoadingModal();
                }).catch(() => {
                    this.hideLoadingModal();
                    this.status_report = 3;
                    this.msg = 'ดาวโหลดข้อมูลไม่สำเร็จ';
                })
            }
        },
        getInvoiceListPage() {
            this.page = this.dataPaginate.current_page;
            if (this.event_submit) {
                this.searchInvoice(this.page);
            } else {
                this.$store.dispatch("Invoice/setInvoiceFilter", {
                    page: this.page,
                    status: this.status
                })
            }
        },
        getFilterStatus(status = 1) {
            this.msg = 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่';
            this.status_report = 1;
            this.showLoadingModal()
            this.status = status;
            this.$store.dispatch("Invoice/setInvoiceFilter", {
                page: 1,
                status: status
            }).then(() => {
                this.hideLoadingModal();
            }).catch(err => {
                this.msg = 'ดาวโหลดข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง';
                this.status_report = 3;
            })
        },
        showApproveModal(id) {
            this.$store.dispatch("Invoice/show", id).then(() => {
                this.$refs.approve.show();
            });
        },
        updateApprove(value) {
            if (value == 'cancel') {
                this.$refs.approve.hide();
            } else {
                let saveData = {
                    id: value.id,
                    action: "save"
                };
                this.$store.dispatch("Invoice/saveInvoice", saveData)
                    .then(() => {
                        this.$refs.approve.hide();
                        this.$store.dispatch("Invoice/setInvoiceFilter", {status: 1})
                    })
            }
        },
        deleteInvoice() {
            let prepare_data = this.id.toString() + ',' + this.note_message;
            this.$store.dispatch("Invoice/delete", prepare_data).then(() => {
                this.hideDeleteModal();
                this.$refs.approve.hide();
                this.status = 8;
                this.$store.dispatch("Invoice/setInvoiceFilter", {status: 8})
            });
        },
        goToTransaction(id) {
            this.$store.dispatch("InvoicePayoff/setDataFromInvoice", id).then(() => {
                this.$store.dispatch("InvoicePayoff/clearTransaction");
                this.$router.push({
                    name: "invoice-payoff",
                    params: {invoice_id: id}
                });
            });
        },
        createTaxNumber() {
            this.msg = 'กำลังสร้างใบกำกับภาษี กรุณารอสักครู่';
            this.status_report = 1;
            this.showLoadingModal()
            this.invoices = [];
            if (this.checkbox_id.length > 0) {
                this.checkbox_id.forEach(invoice => {
                    let data = {
                        invoice_id: invoice.id,
                        date: moment().format("YYYY-MM-DD")
                    };
                    this.invoices.push(data);
                });
                this.$store.dispatch("TaxInvoice/saveTaxInvoice", {
                    id: "",
                    data: this.invoices,
                    user: this.user.username
                }).then(() => {
                    this.checkbox_id = [];
                    this.$store.dispatch("Invoice/setInvoiceFilter", {
                        page: this.page,
                        status: this.status
                    }).then(() => {
                        this.msg = 'สร้างใบกำกับภาษีเสร็จแล้ว';
                        this.status_report = 2;
                    })
                    // this.hideLoadingModal();
                    // this.$router.push("/accounting/tax-invoice");
                }).catch(() => {
                    this.msg = 'สร้างใบกำกับภาษีไม่สำเร็จ';
                    this.status_report = 3;
                });
            }
        },
        printTransportDetails(id) {
            window.open(
                `${domain}/invoice-cover-a5?id=${id}`,
                '_blank'
            );
        },
        printInvoiceReportTableau() {
            let routeData = this.$router.resolve({
                name: 'invoice-report',
            });
            window.open(routeData.href, '_blank');
        },
        printPromotionReportTableau() {
            let routeData = this.$router.resolve({
                name: 'promotion-report',
            });
            window.open(routeData.href, '_blank');
        },
        printInvoiceReport(submit) {
            let start_date = '';
            let end_date = '';
            let customer_id = '';
            let sale_id = '';
            let transport_type_id = this.search.transport_type_id ? this.search.transport_type_id : '';
            let product_id = this.search.product ? this.search.product.id : '';
            // //console.log(this.search)
            if (this.search.date.length == 0 && !this.search.customer && !this.search.sale) {
                alert('กรุณาเลือกวันที่ที่ต้องการออกรายงาน โดยออกรายงานได้ไม่เกิน 40 วัน')
            } else if (this.canSaleOrdersAllView && !this.search.sale) {
                alert('กรุณาเลือกเซลล์ที่ต้องการออกรายงาน')
            } else if (this.date_week.length > 40 && !this.search.customer) {
                alert('เลือกวันระหว่างพิมพ์ไม่เกิน 40 วันเท่านั้น เนื่องจากข้อมูลในการออกรายงานมีจำนวนมาก');
            } else {
                if (this.search.date.length > 0) {
                    start_date = moment(this.search.date[0]).format('YYYY-MM-DD');
                    end_date = moment(this.search.date[1]).format('YYYY-MM-DD');
                }
                if (this.search.customer) {
                    customer_id = this.search.customer.id
                }
                if (this.canSaleOrdersAllView) {
                    if (this.search.sale) {
                        sale_id = this.search.sale.id;
                    }
                } else {
                    sale_id = this.user.id;
                }
                this.showLoadingModal();
                this.msg = 'กำลังดาวน์โหลดรายงานการขาย 1 จาก กำลังคำนวน กรุณารอสักครู่...';
                this.status_report = 1;
                let data = {
                    start_date,
                    end_date,
                    customer_id,
                    sale_id,
                    type_id: this.search.product_type_id ? this.search.product_type_id : '',
                    product_id: product_id,
                    transport_type_id: transport_type_id
                };
                // this.recurPrintInvoiceReport(data);
                this.$store.dispatch("Invoice/reportInvoice", data).then(url => {
                    if (url) {
                        window.open(url);
                        this.hideLoadingModal();
                    } else {
                        this.msg = 'ดาวโหลดรายงานการขายไม่สำเร็จ กรุณาลองใหม่อีกครั้ง';
                        this.status_report = 3;
                    }
                }).catch(err => {
                    this.msg = 'ดาวโหลดรายงานการขายไม่สำเร็จ กรุณาลองใหม่อีกครั้ง';
                    this.status_report = 3;
                })
            }
        },
        recurPrintInvoiceReport(oldData) {
            let data = {
                start_date: oldData.start_date,
                end_date: oldData.end_date,
                customer_id: oldData.customer_id,
                sale_id: oldData.sale_id,
            };
            this.$store.dispatch("Invoice/reportInvoice", data).then(res => {
                if (res.status == 'next') {
                    window.open(res.url);
                    let index = parseInt(res.index) + 1;
                    this.msg = `กำลังดาวน์โหลดรายงานการขาย ${index + 1} จาก ${res.total} กรุณารอสักครู่...`;
                    let newData = {
                        start_date: data.start_date,
                        end_date: data.end_date,
                        customer_id: data.customer_id,
                        sale_id: data.sale_id,
                        index: index,
                        total: res.total
                    }
                    this.recurPrintInvoiceReport(newData);
                } else if (res.status == 'stop') {
                    window.open(res.url);
                    this.hideLoadingModal();
                } else {
                    this.msg = 'ดาวโหลดรายงานการขายไม่สำเร็จ กรุณาลองใหม่อีกครั้ง';
                    this.status_report = 3;
                }
            }).catch(err => {
                this.msg = 'ดาวโหลดรายงานการขายไม่สำเร็จ กรุณาลองใหม่อีกครั้ง';
                this.status_report = 3;
            })
        },
        printPromotionReport() {
            if (this.search.date.length < 1) {
                alert("กรุณาเลือกวันที่")
            }
                // else if(!this.search.sale && this.canViewAccounting){
                //     alert("กรุณาเลือกเซลล์")
            // }
            else if (!this.event_submit) {
                alert("กรุณากดค้นหา")
            } else {
                let start_date = "";
                let end_date = "";
                if (this.search.date.length > 0 && this.search.date[0]) {
                    start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                    end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
                }
                let sale_id = null;
                if (this.canSaleOrdersAllView) {
                    sale_id = this.search.sale ? this.search.sale.id : '';
                } else {
                    sale_id = this.user.id;
                }
                let data = {
                    start_date,
                    end_date,
                    sale_id: sale_id,
                    customer_id: this.search.customer ? this.search.customer.id : ""
                };
                this.showLoadingModal();
                this.msg = "กำลังดาวโหลดข้อมูล กรุณารอสักครู่";
                this.status_report = 1;
                this.$store.dispatch("Invoice/printPromotionReport", data).then(url => {
                    if (url) {
                        window.open(url, '_blank');
                        this.hideLoadingModal();
                    }
                })
            }
        },
        printFormInvoice(submitValue) {
            if (submitValue) {
                const data = $.param(submitValue);
                window.open(domain + '/invoice-form-pdf?' + data,
                    '_blank');
            }
            this.hidePrintFormModal();
            this.$store.dispatch("Invoice/clearFormData");
        },
        printMultiCoverA5() {
            let invoice_id = [];
            this.checkbox_id.forEach(invoice => {
                if (invoice.transport_type_id) {
                    invoice_id.push(invoice.id);
                }
            })
            let id = invoice_id.toString();
            window.open(
                `${domain}/invoice-multi-cover-a5?id=${id}`,
                '_blank'
            );
        },
        printMultiInvoicePDF() {
            if (this.checkbox_id.length > 0) {
                let invoice_id = [];
                this.checkbox_id.forEach(invoice => {
                    if (invoice.id) {
                        invoice_id.push(invoice.id);
                    }
                })
                this.msg = 'กำลังดาวโหลดเอกสาร กรุณารอสักครู่';
                this.status_report = 1;
                this.showLoadingModal()
                this.$store.dispatch("Invoice/printMultiInvoicePDF", invoice_id.toString()).then(url => {
                    if (url) {
                        window.open(url);
                        this.hideLoadingModal();
                    } else {
                        this.msg = 'ไม่มีเอกสารรายการนี้ กรุณาลองใหม่อีกครั้ง';
                        this.status_report = 3;
                        this.showLoadingModal()
                    }
                }).catch(() => {
                    this.msg = 'ดาวโหลดเอกสารไม่สำเร็จ';
                    this.status_report = 3;
                    this.showLoadingModal()
                })
            }
        },
        showInvoiceTaxReport() {
            this.$refs.invoice_tax_report.show()
        },
        hideInvoiceTaxReport() {
            this.$refs.invoice_tax_report.hide()
        },
        printInvoiceTaxReport() {
            this.showInvoiceTaxReport()
        },
        confirmTaxReport() {
            if (!this.tax_report.type || !this.tax_report.date)
                alert('กรุณาเลือกเดือนที่ต้องการออกรายงาน')
            else {
                let data = {
                    date: moment(this.tax_report.date).format('MM-YYYY'),
                    type: this.tax_report.type
                }
                window.open(`${domain}/invoice_tax_report?date=${data.date}&type=${data.type}`, '_blank')
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
    background-color: #FCD61B;
    color: black;
}

.navbar-nav .nav-link {
    color: black;
}

li > .nav-item {
    background-color: gray;
}

</style>
